import React, { FC, Fragment, useContext } from 'react'
import styled from 'styled-components'
import Fonts from 'components/base-ui/Fonts'
import shadow from 'styles/shadow'
import { MEMBERSHIP_PROVIDER, getMembershipCardBgByTier } from 'helpers/membership'
import NoneMemberShipDesc from '../membership/NoneMemberShipDesc'
import { useTranslation } from 'react-i18next'
import { AppContext } from 'contexts/AppProvider'
interface MemberShipGonGangCardProps {
  brandLogo: string
  vendorName: string
  membership: any
}

const MemberShipGonGangCard: FC<MemberShipGonGangCardProps> = ({ membership, brandLogo, vendorName }) => {
  const { brand } = useContext(AppContext)
  const backgroundImage = getMembershipCardBgByTier(membership.memberTier)
  const isShowMemberCard = membership?.provider === MEMBERSHIP_PROVIDER.FOODPASSION && membership?.memberID
  const onConnectMembership = () =>
    (window.location.href = brand?.connectMembershipUrl ? brand.connectMembershipUrl : '')
  const { t } = useTranslation()

  return (
    <Wrapper>
      <SubTitle>{t('membershipTitle')}</SubTitle>
      {isShowMemberCard ? (
        <Fragment>
          <MembershipCard backgroundImage={backgroundImage}></MembershipCard>
        </Fragment>
      ) : (
        <NoneMemberShipDesc onConnectMembership={onConnectMembership} brandLogo={brandLogo} vendorName={vendorName} />
      )}
    </Wrapper>
  )
}

export default MemberShipGonGangCard

const Wrapper = styled.div`
  margin-bottom: 24px;
`

const SubTitle = styled(Fonts.H2)`
  margin-bottom: 8px;
  color: ${({ theme }) => theme.colors.gray800};
`

const MembershipCard = styled.div<{ backgroundImage: string }>`
  position: relative;
  background-size: cover;
  background-position: center;
  overflow: hidden;
  box-shadow: ${shadow.base};
  background-image: url(${({ backgroundImage }) => backgroundImage});
  border-radius: 26px;
  margin-bottom: 10px;

  &::before {
    content: '';
    display: block;
    padding-top: 63%;
  }
`
